'use strict';

var _ = require('lodash');
var qs = require('qs');
var superagent = require('superagent');

// eslint-disable-next-line default-param-last
module.exports = function (method, endpoint) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var config = arguments[3];
  var auth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return new Promise(function (resolve, reject) {
    var url = config.url + endpoint;
    var req = superagent(_.toUpper(method), url);

    if (config.cookie) {
      req.set('cookie', config.cookie);
    }

    if (config.userAgent) {
      req.set('User-Agent', config.userAgent);
    }

    if (config.cacheControl) {
      req.set('Cache-Control', config.cacheControl);
    }

    if (config.pragma) {
      req.set('Pragma', config.pragma);
    }

    if (opts.query) {
      req.query(qs.stringify(opts.query, { encode: false }));
    }

    req.timeout(_.get(config, 'timeout', 30000));

    if (opts.data) {
      req.send(opts.data);
    }

    // Add the supplied token to the authorization header or pulls the access token from the authentication body
    if (opts.token || auth.access_token) {
      req.set('Authorization', 'Bearer ' + (opts.token || auth.access_token));
    }

    req.then(function (res) {
      resolve(res.body);
    }).catch(function (err) {
      reject(err);
    });
  });
};